export default __webpack_public_path__ + "static/media/project_visual_12.cf086094.jpg";